import { baseColors } from '@/theme/tokens/base/colors'
import { opacity } from '@/theme/tokens/base/opacity'
import { createBrandTokens } from '@/theme/tokens/alias/brandTokens'
import { createSemanticColors } from '@/theme/semantic/semanticColors'
import { createSemanticInteraction } from '@/theme/semantic/semanticInteraction'
import { createSemanticSurface } from '@/theme/semantic/semanticSurface'
import type { ThemeTokens } from '@/theme/types'
import { borders } from '@/theme/tokens/base/borders'
import { elevation } from '@/theme/tokens/base/elevation'
import { motion } from '@/theme/tokens/base/motion'
import { radius } from '@/theme/tokens/base/radius'
import { spacing } from '@/theme/tokens/base/spacing'
import { typography } from '@/theme/tokens/base/typography'
import { zIndex } from '@/theme/tokens/base/zIndex'
import { createButtonTokens } from '@/theme/tokens/component/button.tokens'
import { createInputTokens } from '@/theme/tokens/component/input.tokens'
import { createCardTokens } from '@/theme/tokens/component/card.tokens'

export const lightThemeTokens: ThemeTokens = {
  base: {
    colors: baseColors,
    spacing,
    radius,
    typography,
    elevation,
    opacity,
    motion,
    zIndex,
    borders,
  },
  alias: createBrandTokens('light'),
  semantic: {} as ThemeTokens['semantic'],
  components: {} as ThemeTokens['components'],
}

lightThemeTokens.semantic = {
  colors: createSemanticColors(lightThemeTokens.alias, 'light'),
  interaction: createSemanticInteraction(lightThemeTokens.alias, lightThemeTokens.base.opacity, 'light'),
  surface: createSemanticSurface(lightThemeTokens.alias),
}

lightThemeTokens.components = {
  button: createButtonTokens(
    lightThemeTokens.semantic,
    lightThemeTokens.base.radius,
    lightThemeTokens.base.spacing,
  ),
  input: createInputTokens(
    lightThemeTokens.semantic,
    lightThemeTokens.base.radius,
    lightThemeTokens.base.spacing,
  ),
  card: createCardTokens(
    lightThemeTokens.base.radius,
    lightThemeTokens.base.spacing,
    2,
  ),
}

export const lightElevationMap = {
  surface: elevation[1],
  dropdown: elevation[3],
  modal: elevation[4],
  overlay: elevation[5],
}


